<template>
  <div>
    <breadcrumb :routerList="[{to:'/chanp/priceManage',title:'价格管理列表'},{title:'定价信息'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine weekplandetail15">
                    <el-form :model="zy" label-position="right" ref="zy" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="物料型号" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.materialDescrition" disabled="disabled"></el-input>
                      </el-form-item>
                      <el-form-item label="物料编码" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.materialCode" disabled="disabled"></el-input>
                      </el-form-item>
                      <el-form-item label="产品大类" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.levelname" disabled="disabled"></el-input>
                      </el-form-item>
                      <!--<el-form-item label="物料组" prop="materialGroupCode" class="h-elformWrap-2">-->
                      <!--<brselectlazy category="YLMaterialGroup" :v="zy.materialGroupCode" v-model="zy.materialGroupCode" :disabled="true"></brselectlazy>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="定价状态" class="h-elformWrap-2">-->
                      <!--<el-input placeholder="" v-model="zy.setprice" disabled="disabled"></el-input>-->
                      <!--</el-form-item>-->
                      <el-form-item label="型号经理" class="h-elformWrap-2">
                        <el-input v-model="zy.typeUserCode" oninput="value=value.replace(/[^\d]/g, '')"
                                  readonly></el-input>
                      </el-form-item>
                      <el-form-item label="型号属性" class="h-elformWrap-2" prop="protype">
                        <el-input v-model="zy.protype" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="毛利率" class="h-elformWrap-2" prop="gross" v-show="isShowChengbeng">
                        <el-input v-model="zy.gross" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="成本" class="h-elformWrap-2" prop="cost" v-show="isShowChengbeng">
                        <el-input v-model="zy.cost" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="含税单价" class="h-elformWrap-2" prop="unitPrice" v-show="isShowChengbeng">
                        <el-input v-model="zy.unitPrice" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="不含税单价" class="h-elformWrap-2" prop="unitSellingPrice"
                                    v-show="isShowChengbeng">
                        <el-input v-model="zy.unitSellingPrice" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="是否计入销额" class="h-elformWrap-2" prop="xiaoe">
                        <brselect category="xiaoe_jishu" :v="zy.xiaoe" v-model="zy.xiaoe"></brselect>
                      </el-form-item>
                      <el-form-item label="是否计入基数" class="h-elformWrap-2" prop="jishu">
                        <brselect category="xiaoe_jishu" :v="zy.jishu" v-model="zy.jishu"></brselect>
                      </el-form-item>
                      <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                        <el-input v-model="zy.factory" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="市场分类" prop="marketType" class="h-elformWrap-2">
                        <template>
                          <brselectlazy category="market_type" :v="zy.marketType" v-model="zy.marketType"
                                        disabled=""></brselectlazy>
                        </template>
                      </el-form-item>
                      <el-form-item label="场景分类" prop="sceneName" class="h-elformWrap-2">
                        <el-input v-model="zy.sceneName" readonly></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="h-rowBox" style="margin-top:30px;padding:0;">
            <div class="h-rowCon Dingjia" style="padding-bottom:0">
              <div class="h-pieceIn2" style="padding-left:0.26rem;">
                <div class="h-pieceTitle2"
                     style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                  <h1>定价信息</h1>
                </div>
              </div>
              <el-table
                  ref="multipleTable"
                  @selection-change="handleSelectionChange"
                  :data="tableData3"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="600"
              >
                <el-table-column
                    type="selection"
                    width="40"
                    :label="all"
                >
                </el-table-column>
                <el-table-column
                    type="index"
                    width="40"
                    label="#">
                </el-table-column>
                <el-table-column
                    prop="leixing"
                    label="定价类型"
                >
                  <template slot-scope="scope">
                    <!-- <el-select v-model="scope.row.leixing" placeholder="请选择" @change="changejibiequyu(scope.row)"  disabled="disabled" >
                        <el-option
                            v-for="(item) in dingjialeixing"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select> -->
                    <div v-if="scope.row.leixing == 1">内销</div>
                    <div v-if="scope.row.leixing == 0">外销</div>
                    <div v-if="scope.row.leixing == 2">外贸</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="jibie"
                    label="级别/区域">

                </el-table-column>
                <el-table-column
                    prop="bizhong"
                    label="币种">
                  <!-- <template slot-scope="scope">
                      <el-select v-model="scope.row.bizhong"  style="width:100%" disabled="disabled" >
                          <el-option v-for="item in bizhongListops" :key="item.code"
                                     :label="item.name" :value="item.code" >
                          </el-option>
                      </el-select>

                  </template> -->
                </el-table-column>
                <el-table-column
                    prop="jiage"
                    label="价格">
                  <template slot-scope="scope">
                    <div style="text-align: right;">{{ scope.row.jiage }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="youxiaoqi"
                    label="有效期"
                >
                  <template slot-scope="scope">
                    <!-- <el-col style="display: flex;justify-content: center;align-items: center;">
                        <el-date-picker
                            disabled="disabled"
                            v-model="scope.row.youxiaoqi"
                            type="daterange"
                            range-separator=" 至 "
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-col> -->
                    <div>{{ scope.row.youxiaoqi[0] }}至{{ scope.row.youxiaoqi[1] }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="isuse"
                    label="是否可用"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="instid"
                    label="查看进度"
                    fixed="right"
                    width="100"
                >
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.instid" type="text" size="small" class="h-tableLink h-btn"
                               @click="chakanjindu(scope.row.instid)">查看进度
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
      </div>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL">
          <el-button v-if="adminFlag" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     @click="outexcel">批量导出
          </el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
        </div>
      </div>
      <div class="h-txtCenter h-mrt60">
        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="quxiao">返回</el-button>
        <!--                        <el-button class="h-btn h-bBtn h-bggreen" @click="dingjiaanniu(0)">暂存</el-button>-->
        <!--                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="dingjiaanniu(1)">确认提交</el-button>-->
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../api/SystemService';

export default {
  data() {
    let that = this
    return {

      bizhongListops: [],

      YlSalesAreawaioxiaolist: [],

      customergrouplist: [],

      //显示进度id
      instid: '',
      //显示进度标志
      showhistory: false,
      fanhuizancun: [],
      bianlianga: '',
      //要删除的
      yaoshanchude: [],
      //查询定价集合
      dingjiajihe: [
        {
          leixing: '',
          jibie: '',
          bizhong: '',
          jiage: '',
          youxiaoqi: ['', ''],
        }
      ],
      q: {
        materialid: this.$router.history.current.query.materialCode,
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //币种
      bizhonglist: [],
      //区域
      YlSalesArea: [],
      //前页转发内容
      chanpinneirong: {},
      //定价id
      dingjiaid: '',
      dingjialeixing: [{
        value: '',
        label: '--请选择--'
      },{
        value: 2,
        label: '外贸'
      }, {
        value: 1,
        label: '内销'
      }, {
        value: 0,
        label: '外销'
      }],
      jibie: [{
        value: '',
        label: '--请选择--'
      },],
      quyu: [{
        value: '',
        label: '--请选择--'
      },],
      //配置集合
      configlist: {},
      bizhongop: [{
        value: '',
        label: '--请选择--'
      },],
      all: "全部",
      formInline: {
        names: '',
        starttime: '',
        endtime: '',
        areaName: ''
      },
      options1: [{
        value: '选项1',
        label: '渠道1'
      }, {
        value: '选项2',
        label: '渠道2'
      }],
      pickerOptions: {
        disabledDate(time) {
          let endDate = that.formInline.endtime;
          let startDate = that.formInline.starttime;
          return time.getTime() < new Date(startDate).getTime() || time.getTime() >= new Date(endDate).getTime()
        }
      },
      options2: [],
      zy: {},
      tableData3: [
        {
          leixing: '',
          jibie: '',
          bizhong: '',
          jiage: '',
          youxiaoqi: ['', ''],
        }
      ],
      optionsCustomer: [],
      optionsAgent: [],
      userCarePlan: {},
      totalbizhong: '',
      totalbizhong2: '',
      totalbizhong3: "",
      totalbizhong4: "",
      isShowChengbeng: false,//是否展示成本信息
      adminFlag: false,
    }
  },
  mounted() {

  },

  created() {
    //是否管理员权限
    this.adminFlag = this.$store.getters.hasRole('swyl_admin');

    this.YlSalesAreawaioxiaolist = this.$store.getters.dictlist("neibu_haiwai_area");

    this.customergrouplist = this.$store.getters.dictlist("customer_group");

    //当前角色 如果有一下角色不允许展示成本信息
    if (this.$store.getters.hasRole('swyl_xiaoshoujl_wx')) {
      this.isShowChengbeng = false;
    }


    this.bizhongjiazai();

    this.options2 = this.$store.getters.dicts["userCareType"];

    //前页信息
    this.chanpinneirong = this.$router.history.current.query;

    //物料号
    this.dingjiaid = this.$router.history.current.query.materialCode;

    //上头内容
    this.zy = this.$router.history.current.query;

    // this.fff();
    //
    // this.huoqupeizhi();

    this.query();

  },

  beforeRouteLeave(to, from, next) {
    if (to.path == '/chanp/priceManage' && from.path == '/chanp/priceOnlyRead') {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },


  methods: {


    //币种加载
    bizhongjiazai() {


      ss.Dictservice.listbycategory("YLCurrency").then(rd => {

        console.log(rd, '字典结果')
        this.bizhongListops = rd;


      })

    },


    //查看进度
    chakanjindu(q) {

      console.log(q, '看看instid')

      this.instid = q;

      this.showhistory = true;

    },


    //导表
    outexcel() {

      var idf = [];

      for (var f in this.tableData3) {

        idf.push(this.tableData3[f].id);

      }


      var ids = [];


      for (var d in this.multipleSelection) {

        ids.push(this.multipleSelection[d].id);


      }

      if (ids.length > 0 ? false : idf.length > 0 ? false : true) {

        this.$msg.msgs("没有信息")

      } else {

        ss.chanpin.downloadExcelByIds(ids.length > 0 ? ids : idf.length > 0 ? idf : null);

      }


    },


    //查找定价
    query(q) {
      ss.chanpin.dingjiaselectPage(this.q).then(rd => {
        console.log(rd.records, 'asdasdefrgr')
        this.tableData3 = null;
        this.tableData3 = rd.records;
        this.q.total = rd.total;
        this.jiazaibiao(rd.records);
      })
    },



    //加载表
    jiazaibiao(q) {
      this.tableData3 = [];

      for (var y in q) {
        for (var i = 0; i < this.YlSalesAreawaioxiaolist.length; i++) {
          if (this.YlSalesAreawaioxiaolist[i].code == q[y].type) {
            q[y].type = this.YlSalesAreawaioxiaolist[i].name;
          }
        }
        for (var i = 0; i < this.customergrouplist.length; i++) {
          if (this.customergrouplist[i].code == q[y].type) {
            q[y].type = this.customergrouplist[i].name;
          }
        }
        for (var i = 0; i < this.bizhongListops.length; i++) {
          if (this.bizhongListops[i].code == q[y].currency) {
            q[y].currency = this.bizhongListops[i].name;
          }
        }
        var list = {
          leixing: q[y].leltypecode,
          jibie: q[y].type,//类型的值  级别或者区域
          bizhong: q[y].currency,//币种
          jiage: q[y].value,//定价金额
          leixingflag: q[y].leltypecode,//类型的flag
          id: q[y].id,//定价id主键
          youxiaoqi: [q[y].startdate, q[y].effectivedate],//定价有效期
          materialid: q[y].materialid,//物料id
          bianlianga: q[y].leltypecode == 0 ? 'neibu_haiwai_area' : q[y].leltypecode == 1 ? 'customer_group' :q[y].leltypecode == 2?'neibu_haiwai_area':'',
          ispass: q[y].ispass,//审核标志   0 未通过   1 通过   2暂存  3提交审核中
          instid: q[y].instid,//审批流id
          isuse: q[y].isuse == 1 ? "可用" : "不可用",
        }
        this.tableData3.push(list)
      }
    },
    //更换级别区域
    changejibiequyu(q) {
      console.log(q, '看看是多少')
      this.jiazaijibiequyu(q);
    },
    //添加框
    add() {
      console.log(this.chanpinneirong, '看看有啥')
      var list = {
        materialid: this.chanpinneirong.materialCode,
        leixing: '',
        jibie: '',
        bizhong: '',
        jiage: '',
        youxiaoqi: '',
      }
      this.tableData3.push(list)
    },
    //删除框
    delPlan(index, q) {
      //如果原来有数据
      if (q.id != null) {//把要删除的定价主键id存起来
        this.yaoshanchude.push({id: q.id});
      }
      this.tableData3.splice(index, 1)
      //console.log(index,"删除一行数据");
    },
    //提交/暂存 按钮
    dingjiaanniu(q) {
      console.log(this.yaoshanchude, 'aaa????')
      //默认先删除
      ss.chanpin.dingjialuojishanchu(this.yaoshanchude).then(rd => {
        //若要删除的id有的话
        if (this.yaoshanchude.length > 0) {
          console.log('进来没有')
          if (rd.f) {//如果删除成功的话
            //进入按钮
            this.jinruanniu(q);
          }
        } else {//若没有要删除的话

          //进入按钮
          this.jinruanniu(q);
        }
      })
    },
    jinruanniu(q) {
      if (q == 0) {
        this.zancun();//暂存定价信息
      } else if (q == 1) {
        this.qudingjia();//去发起定价审批
      }
    },
    //暂存定价
    zancun() {
      var canshu = [];
      for (var t in this.tableData3) {
        console.log(this.tableData3[t], '看看每一个')
        canshu.push({
          id: this.tableData3[t].id,
          materialid: this.tableData3[t].materialid,
          leltypecode: this.tableData3[t].leixingflag,
          type: this.tableData3[t].jibie,
          value: this.tableData3[t].jiage,
          currency: this.tableData3[t].bizhong,
          startdate: this.tableData3[t].youxiaoqi[0],
          effectivedate: this.tableData3[t].youxiaoqi[1],
          ispass: this.tableData3[t].ispass,
        })
      }
      console.log(canshu, '参数穿没穿')
      //暂存定价信息
      ss.chanpin.dingjiazengjiazancun(canshu).then(rd => {
        this.$msg.msgs(rd.msg)
        console.log(rd.obj, '反美反回来')
        this.fanhuizancun = rd.obj;
        this.jiazaibiao(rd.obj);
        this.query(this.chanpinneirong)
      })
    },
    //去定价，发定价审批  启动审批流
    qudingjia() {
      //发起提交审核定价  启动审批流
      this.faqidingjia();
    },
    //发起定价 启动审批流
    faqidingjia() {
      console.log(this.tableData3, 'tableData3')
      if (this.tableData3.length != 0) {
        var data = {
          materialid: this.dingjiaid,
          xiaoe: this.zy.xiaoe,
          jishu: this.zy.jishu,
          factory: this.zy.factory,
        }

        ss.chanpin.gotoSetPrice(data).then(rd => {
          this.$msg.msgs(rd.msg);
          this.$router.go(-1);
        })
      }
    },
    //取消
    quxiao() {
      this.$router.go(-1);
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    //更换数据字典名
    jiazaijibiequyu(q) {
      if (q.leixing == 0) {
        q.bianlianga = 'neibu_haiwai_area';
        q.leixingflag = 0;
      }
      if (q.leixing == 1) {
        q.bianlianga = 'customer_group';
        q.leixingflag = 1;
      }
      if(q.leixing == 2){
        q.bianlianga='neibu_haiwai_area';
        q.leixingflag=2;

      }
    }
  },

}
</script>
<style>
.Dingjia .el-range-editor.is-disabled .el-range-separator {
  width: 9%;
}

.weekplandetail15 .h-formbLine .el-form-item__label {
  width: 31%;
  text-align: right;
}

.weekplandetail15 .h-formbLine .el-form-item__content {
  width: 69%;
}

.weekplandetail15 .h-formbLine .h-elformWrap-2 {
  width: 33.333% !important;
  padding-right: 0.5rem
}

.weekplandetail15 .h-formbLine .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem
}

.weekplandetail15 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 9.7%;
}

.weekplandetail15 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 90.3%;
}
</style>
